// ขั้นงาน 8 ขั้น + ยกเลิก — ใช้ร่วมกันทุกหมวดงาน (แทน 30 สถานะของระบบเดิม)
// ดู docs/DESIGN.md หัวข้อ 3
export const STAGES = [
    'intake',
    'scheduled',
    'diagnosing',
    'awaiting_approval',
    'in_progress',
    'ready',
    'admin_review',
    'closed',
    'cancelled',
];
export const OPEN_STAGES = ['intake', 'scheduled', 'diagnosing', 'awaiting_approval', 'in_progress', 'ready', 'admin_review'];
/** ขั้นที่ช่างยังต้องลงมือ (ไม่นับ "รอแอดมิน" ที่งานหน้างานเสร็จแล้ว) — ใช้กับ SLA และรายการงานของช่าง */
export const WORK_STAGES = ['intake', 'scheduled', 'diagnosing', 'awaiting_approval', 'in_progress', 'ready'];
export const TERMINAL_STAGES = ['closed', 'cancelled'];
export const STAGE_INFO = {
    intake: { label: 'รับเรื่อง', short: 'รับเรื่อง', color: 'sky', description: 'ลูกค้าแจ้งเข้ามา รอคัดกรอง' },
    scheduled: { label: 'นัดหมาย', short: 'นัดแล้ว', color: 'violet', description: 'นัดหน้างาน/รับเครื่องแล้ว มอบหมายช่างแล้ว' },
    diagnosing: { label: 'ตรวจเช็ค', short: 'ตรวจเช็ค', color: 'amber', description: 'ได้เครื่องหรือถึงหน้างานแล้ว กำลังหาสาเหตุ' },
    awaiting_approval: { label: 'รออนุมัติ', short: 'รออนุมัติ', color: 'orange', description: 'ส่งราคาให้ลูกค้าแล้ว รอตอบ' },
    in_progress: { label: 'กำลังทำ', short: 'กำลังทำ', color: 'blue', description: 'ซ่อม ติดตั้ง หรือแก้ไขอยู่' },
    ready: { label: 'เสร็จ รอส่งมอบ', short: 'รอส่งมอบ', color: 'green', description: 'งานเสร็จ รอลูกค้ารับหรือเซ็น' },
    admin_review: { label: 'รอแอดมิน', short: 'รอแอดมิน', color: 'violet', description: 'ช่างทำงานเสร็จแล้ว รอแอดมินผูกเลขเอกสารหรือยืนยันไม่คิดเงิน แล้วปิดงาน' },
    closed: { label: 'ปิดงาน', short: 'ปิดแล้ว', color: 'slate', description: 'ส่งมอบแล้ว เริ่มนับประกัน' },
    cancelled: { label: 'ยกเลิก', short: 'ยกเลิก', color: 'rose', description: 'ยกเลิกงาน' },
};
/** ชื่อขั้นที่ลูกค้าเห็น (หน้าติดตามงาน) — ไม่โชว์ขั้นภายในอย่าง "รอแอดมิน" */
const PUBLIC_LABEL = { admin_review: 'งานเสร็จแล้ว' };
export function publicStageLabel(s) {
    return PUBLIC_LABEL[s] ?? STAGE_INFO[s]?.label ?? s;
}
export function isStage(v) {
    return typeof v === 'string' && STAGES.includes(v);
}
export function isOpenStage(s) {
    return OPEN_STAGES.includes(s);
}
const ORDER = Object.fromEntries(STAGES.map((s, i) => [s, i]));
/**
 * ขั้นที่ไปต่อได้ (ไปข้างหน้า) — ข้ามได้บางขั้น เช่น งานในประกันไม่ต้องรออนุมัติ
 * งานเสร็จ → "รอแอดมิน" (admin_review) → ปิดงาน · ปิดตรงจาก ready ไม่ได้ (ต้องผ่านแอดมินเพื่อผูกเอกสาร/ยืนยันไม่คิดเงิน)
 */
export const FORWARD = {
    intake: ['scheduled', 'diagnosing', 'in_progress'],
    scheduled: ['diagnosing', 'in_progress'],
    diagnosing: ['awaiting_approval', 'in_progress', 'ready'],
    awaiting_approval: ['in_progress', 'ready'],
    in_progress: ['ready', 'admin_review'],
    ready: ['admin_review'],
    admin_review: ['closed'],
    closed: [],
    cancelled: [],
};
export function forwardTargets(from, opts = {}) {
    if (opts.adminReview === false) {
        if (from === 'ready')
            return ['closed'];
        if (from === 'in_progress')
            return ['ready'];
    }
    return FORWARD[from];
}
/**
 * ตรวจการย้ายขั้น
 * - ไปข้างหน้า: ตาม FORWARD
 * - ถอยกลับ: ถอยไปขั้นเปิดใดก็ได้ที่อยู่ก่อนหน้า ต้องมีเหตุผล (เช่น ลูกค้าไม่อนุมัติ → กลับไปตรวจเช็ค)
 * - ยกเลิก: จากขั้นเปิดใดก็ได้ ต้องมีเหตุผล
 * - เปิดงานใหม่ (reopen): closed/cancelled → ready หรือ intake ต้องมีเหตุผล (admin/office เท่านั้น — ตรวจที่ permissions)
 */
export function checkTransition(from, to, opts = {}) {
    if (from === to)
        return { ok: false, needsReason: false, error: 'งานอยู่ขั้นนี้อยู่แล้ว' };
    if (to === 'cancelled') {
        if (!isOpenStage(from))
            return { ok: false, needsReason: true, error: 'งานนี้ปิดหรือยกเลิกไปแล้ว' };
        return { ok: true, kind: 'cancel', needsReason: true };
    }
    if (TERMINAL_STAGES.includes(from)) {
        if (from === 'closed' && to === 'ready')
            return { ok: true, kind: 'reopen', needsReason: true };
        if (from === 'cancelled' && to === 'intake')
            return { ok: true, kind: 'reopen', needsReason: true };
        return { ok: false, needsReason: true, error: 'งานที่ปิดแล้วเปิดใหม่ได้เฉพาะกลับไปขั้นก่อนหน้า' };
    }
    if (forwardTargets(from, opts).includes(to))
        return { ok: true, kind: 'forward', needsReason: false };
    if (isOpenStage(to) && ORDER[to] < ORDER[from])
        return { ok: true, kind: 'back', needsReason: true };
    return {
        ok: false,
        needsReason: false,
        error: `ย้ายจาก "${STAGE_INFO[from].label}" ไป "${STAGE_INFO[to].label}" ไม่ได้`,
    };
}
/** ขั้นถัดไปที่แนะนำ (ใช้ทำปุ่มใหญ่ "ไปขั้นถัดไป") */
export function suggestedNext(from, opts = {}) {
    const review = opts.adminReview !== false;
    switch (from) {
        case 'intake':
            return 'scheduled';
        case 'scheduled':
            return 'diagnosing';
        case 'diagnosing':
            return opts.skipApproval ? 'in_progress' : 'awaiting_approval';
        case 'awaiting_approval':
            return 'in_progress';
        case 'in_progress':
            // งานหน้างานไม่มีขั้นรอลูกค้ามารับเครื่อง → ส่งให้แอดมินได้เลย · งานซ่อมที่ร้านต้องรอส่งมอบก่อน
            return review && opts.category && opts.category !== 'shop_repair' ? 'admin_review' : 'ready';
        case 'ready':
            return review ? 'admin_review' : 'closed';
        case 'admin_review':
            return 'closed';
        default:
            return null;
    }
}
// ---------- ป้ายพักงาน ----------
export const HOLD_REASONS = ['parts', 'vendor_claim', 'customer', 'site_access', 'revisit', 'utility'];
export const HOLD_INFO = {
    parts: { label: 'รออะไหล่' },
    vendor_claim: { label: 'รอเคลมศูนย์' },
    customer: { label: 'รอลูกค้าตอบ' },
    site_access: { label: 'รอเข้าพื้นที่/ใบอนุญาต' },
    revisit: { label: 'รอเข้ารอบ 2' },
    utility: { label: 'รอการไฟฟ้า' },
};
export function isHoldReason(v) {
    return typeof v === 'string' && HOLD_REASONS.includes(v);
}
// รอแอดมินพักได้ เช่น "รอลูกค้าตอบใบเสนอราคา"
const HOLDABLE = ['diagnosing', 'awaiting_approval', 'in_progress', 'ready', 'admin_review'];
export function canHold(stage) {
    return HOLDABLE.includes(stage);
}
// ---------- หมวดงาน / ช่องทาง / ความเร่งด่วน ----------
export const CATEGORIES = ['shop_repair', 'onsite_service', 'installation', 'maintenance'];
export const CATEGORY_INFO = {
    shop_repair: { label: 'ซ่อมที่ร้าน', color: 'sky' },
    onsite_service: { label: 'บริการหน้างาน', color: 'orange' },
    installation: { label: 'งานติดตั้ง', color: 'violet' },
    maintenance: { label: 'MA / PM', color: 'green' },
};
export const CHANNELS = ['phone', 'line', 'walkin', 'qr', 'web', 'email', 'ma', 'monitor', 'bot', 'mcp', 'legacy'];
export const CHANNEL_INFO = {
    phone: { label: 'โทรศัพท์' },
    line: { label: 'LINE' },
    walkin: { label: 'Walk-in' },
    qr: { label: 'สแกน QR' },
    web: { label: 'เว็บไซต์' },
    email: { label: 'อีเมล' },
    ma: { label: 'สัญญา MA' },
    monitor: { label: 'ระบบมอนิเตอร์' },
    bot: { label: 'บอท LINE' },
    mcp: { label: 'Claude (MCP)' },
    legacy: { label: 'ระบบเดิม' },
};
export const PRIORITIES = ['low', 'normal', 'high', 'urgent'];
export const PRIORITY_INFO = {
    low: { label: 'ไม่รีบ' },
    normal: { label: 'ปกติ' },
    high: { label: 'ด่วน' },
    urgent: { label: 'ด่วนมาก' },
};
export const OUTCOMES = ['completed', 'unrepairable'];
// ---------- รอบเข้าหน้างาน ----------
export const VISIT_KINDS = ['onsite', 'pickup', 'delivery', 'survey'];
export const VISIT_KIND_INFO = {
    onsite: { label: 'เข้าหน้างาน' },
    pickup: { label: 'ไปรับเครื่อง' },
    delivery: { label: 'ส่งคืนเครื่อง' },
    survey: { label: 'สำรวจหน้างาน' },
};
export const VISIT_STATUSES = ['scheduled', 'en_route', 'on_site', 'done', 'cancelled'];
export const VISIT_STATUS_INFO = {
    scheduled: { label: 'นัดแล้ว', action: 'นัด' },
    en_route: { label: 'กำลังไป', action: 'ออกเดินทาง' },
    on_site: { label: 'ถึงแล้ว', action: 'ถึงหน้างาน' },
    done: { label: 'เสร็จรอบ', action: 'จบรอบนี้' },
    cancelled: { label: 'ยกเลิกรอบ', action: 'ยกเลิก' },
};
const VISIT_NEXT = {
    scheduled: ['en_route', 'on_site', 'cancelled'],
    en_route: ['on_site', 'cancelled'],
    on_site: ['done'],
    done: [],
    cancelled: [],
};
export function canVisitTransition(from, to) {
    return VISIT_NEXT[from].includes(to);
}
//# sourceMappingURL=stages.js.map